"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.739 6.217a.55.55 0 0 0-.946-.383L6.616 8.088a1.7 1.7 0 0 1-1.223.519H4.7a.3.3 0 0 0-.3.3v2.186a.3.3 0 0 0 .3.3h.693a1.7 1.7 0 0 1 1.223.519l2.177 2.254a.55.55 0 0 0 .946-.383zM7.787 4.862c1.218-1.261 3.352-.399 3.352 1.355v7.566c0 1.754-2.134 2.616-3.352 1.355l-2.178-2.253a.3.3 0 0 0-.216-.092H4.7a1.7 1.7 0 0 1-1.7-1.7V8.907a1.7 1.7 0 0 1 1.7-1.7h.693a.3.3 0 0 0 .216-.092zm4.32 2.298a.7.7 0 0 1 .965-.219c.955.603 1.539 1.78 1.539 3.062s-.584 2.46-1.542 3.058a.7.7 0 0 1-.741-1.188c.477-.297.883-.982.883-1.87 0-.887-.405-1.574-.886-1.878a.7.7 0 0 1-.218-.966",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.917 5.162a.7.7 0 0 1 .987-.073C16.194 6.199 17 8.003 17 10.002c0 1.996-.805 3.798-2.092 4.91a.7.7 0 0 1-.915-1.06c.946-.818 1.607-2.216 1.607-3.85 0-1.637-.662-3.036-1.61-3.853a.7.7 0 0 1-.073-.987",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=MuteIcon20.js.map